// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/src/plugins/manualColumnMove/manualColumnMove.css
// module id = 508
// module chunks = 0